import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { useRecordContext, useResourceContext } from 'react-admin';
import { Box, Stepper, Step, StepLabel, Typography, } from '@mui/material';
import { formatDistanceToNow } from 'date-fns/formatDistanceToNow';
import { useGetRevisions } from '../dataProvider';
export var RevisionList = function (props) {
    var _a;
    var _b = props.renderName, renderName = _b === void 0 ? function (id) { return id; } : _b, _c = props.onRevisionClick, onRevisionClick = _c === void 0 ? defaultOnRevisionClick : _c, _d = props.keepSelection, keepSelection = _d === void 0 ? false : _d, sx = props.sx;
    var record = useRecordContext(props);
    var resource = useResourceContext(props);
    if (!resource) {
        throw new Error('The RevisionList component must be used inside a ResourceContext or must be passed a resource prop.');
    }
    var _e = useGetRevisions(resource, {
        recordId: (_a = record === null || record === void 0 ? void 0 : record.id) !== null && _a !== void 0 ? _a : 0,
    }, { enabled: !!record }), revisions = _e.data, isPending = _e.isPending;
    var _f = React.useState(0), activeStep = _f[0], setActiveStep = _f[1];
    if (isPending)
        return null;
    return (_jsx(Stepper, { nonLinear: true, activeStep: activeStep, orientation: "vertical", sx: sx, children: revisions === null || revisions === void 0 ? void 0 : revisions.map(function (revision, index) { return (_jsx(Step, { onClick: function () {
                keepSelection && setActiveStep(index);
                onRevisionClick(revision);
            }, children: _jsxs(StepLabel, { StepIconProps: {
                    icon: revisions.length - index,
                }, sx: {
                    padding: 0,
                    '& .MuiStepLabel-labelContainer': {
                        width: 'calc(100% - 25px)',
                    },
                    '&:hover': {
                        cursor: 'pointer',
                        '& .MuiStepLabel-labelContainer': {
                            color: 'text.primary',
                        },
                    },
                }, children: [_jsx(Box, { sx: {
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        }, children: revision.message }), _jsxs(Typography, { variant: "caption", component: "div", children: [_jsx("span", { title: new Date(revision.date).toLocaleString(), children: formatDistanceToNow(new Date(revision.date), {
                                    addSuffix: true,
                                    // @ts-ignore date-fns invites to use a global locale, see https://date-fns.org/v2.16.1/docs/I18n
                                    locale: window === null || window === void 0 ? void 0 : window.___dateFnsLocale,
                                }) }), ' ', "- ", renderName(revision.authorId)] })] }) }, revision.id)); }) }));
};
// eslint-disable-next-line @typescript-eslint/no-empty-function
var defaultOnRevisionClick = function (_revision) { };
